<template>
  <div>
    <v-container class="pa-0" fluid>
      <!-- Toolbar -->
      <v-row style="height: 48px; max-height: 48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Crear, Modificar y Desactivar Metros de Sucursales'"
          :show-absolute="false"
          :titulo="'Metros'"
          @MethodEliminar="eliminar"
          @MethodGuardar="guardar"
          @MethodNuevo="newwnuevo"
          @abrirBarraTablaDinamica="abrirTabla"
        />
      </v-row>
      <!-- fn Toolbar  -->

      <v-row>
        <!-- Barra de busqueda --->
        <v-col
          v-show="showBarraPrimaria"
          class="pr-0"
          cols="3"
          style="max-height: calc(100vh - 48px - 57px - 64px); overflow-y: scroll"
        >
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <BarraDinamicaLimitePlus
                :ContListSlot="[{ Text: 'Descripcion', NomValue: 'descripcion', Ctsl: 1, Type: 0, State: true }]"
                :PropsList="sucursalList"
                :PropsNombre="'Sucursales'"
                :PropsSeachNombre="'Búsqueda por descripcion'"
                :TbPaginator="paginador"
                :TbTotalItem="totalItems"
                :headers="[]"
                props-search
                @CargarPaginacion="cargarPaginacion"
                @EmitDAta="datostabla"
              />
            </template>
          </v-tooltip>
        </v-col>
        <!-- Fin Barra de busqueda --->

        <!-- Contenido central --->
        <v-col style="max-height: calc(100vh - 48px - 57px - 64px); overflow-y: scroll">
          <div class="px-2">
            <v-card color="grey lighten-3">
              <div class="px-2">
                <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
                  <v-row>
                    <v-col cols="12" md="6" sm="6">
                      <!-- ----------------------------- Nombre -->

                      <v-text-field v-model="sucursalMetro.descripcion" dense label="Nombre:" outlined readonly>
                        <template v-slot:prepend>
                          <i class="fa fa-font" style="font-size: 20px; width: 20px"></i>
                        </template>
                      </v-text-field>

                      <!-- ----------------------------- teléfono -->
                      <v-text-field
                        v-model="sucursalMetro.telefono"
                        dense
                        label="Teléfono:"
                        maxlength="13"
                        outlined
                        readonly
                      >
                        <template v-slot:prepend>
                          <i class="fa fa-phone" style="font-size: 20px; width: 20px"></i>
                        </template>
                      </v-text-field>

                      <div class="d-flex justify-center">
                        <v-switch v-model="sucursalMetro.activada" label="Activo" readonly></v-switch>
                      </div>
                    </v-col>

                    <v-col cols="12" md="6" sm="6">
                      <!-- -----------------------------  Codigo -->

                      <v-text-field v-model="sucursalMetro.codigo" dense label="Codigo:" outlined readonly>
                        <template v-slot:prepend>
                          <i class="fa fa-list-ol" style="font-size: 20px; width: 20px"></i>
                        </template>
                      </v-text-field>

                      <!-- ----------------------------- direccion -->
                      <v-textarea v-model="sucursalMetro.direccion" dense label="Direccion:" outlined readonly rows="2">
                        <template v-slot:prepend>
                          <i class="fa fa-map-marker" style="font-size: 20px; width: 20px"></i>
                        </template>
                      </v-textarea>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
            </v-card>

            <v-col cols="12">
              <v-data-table
                :key="sucursalMetro.codigo"
                :footer-props="{
                  disableItemsPerPage: true,
                }"
                :headers="metroHeaders"
                :items="metroList.content"
                :items-per-page="pageSize"
                :server-items-length="metroList.totalElements"
                class="elevation-1"
                dense
                no-data-text="Esta sucursal no tiene metros asignados"
                @update:page="changePage"
              >
                <template #body.prepend>
                  <tr v-show="sucursalMetro.codigo !== 0">
                    <td>
                      <v-text-field v-model="metro.nombre" :error="errors.nombre" dense hide-details></v-text-field>
                    </td>
                    <td>
                      <v-autocomplete
                        v-model="metro.tipoGas"
                        :error="errors.tipoGas"
                        :items="tipoGasList"
                        dense
                        hide-details
                        item-text="descripcion"
                        return-object
                        @focus.once="findAllTipoGas"
                      ></v-autocomplete>
                    </td>
                    <td>
                      <v-autocomplete
                        v-model="metro.llenador"
                        :error="errors.llenador"
                        :items="llenadorList"
                        :search-input.sync="searchLlenador"
                        dense
                        hide-details
                        item-text="nombre"
                        no-filter
                        return-object
                      ></v-autocomplete>
                    </td>
                    <td>
                      <VueAutonumeric
                        v-model.number="metro.lecturaInicial"
                        autocomplete="off"
                        dense
                        hide-details
                      ></VueAutonumeric>
                    </td>
                    <td style="max-width: 6rem">
                      <VueAutonumeric
                        v-model.number="metro.posicion"
                        :an-options="{ decimalPlaces: 0 }"
                        autocomplete="off"
                        dense
                        hide-details
                      ></VueAutonumeric>
                    </td>
                    <td>
                      <v-btn-toggle>
                        <v-btn color="green" small @click="saveMetro">
                          <i class="fa fa-plus" style="color: white"></i>
                        </v-btn>
                        <v-btn color="grey" small @click="resetMetroForm">
                          <i class="fa fa-refresh" style="color: white"></i>
                        </v-btn>
                      </v-btn-toggle>
                    </td>
                  </tr>
                </template>

                <template #item.nombre="{ item }">
                  <v-text-field v-model="item.nombre" :error="errors.nombre" dense hide-details></v-text-field>
                </template>

                <template #item.tipoGas.descripcion="{ item }">
                  <v-autocomplete
                    v-model="item.tipoGas"
                    :error="errors.tipoGas"
                    :items="tipoGasList"
                    dense
                    hide-details
                    item-text="descripcion"
                    return-object
                    @focus.once="findAllTipoGas"
                  ></v-autocomplete>
                </template>

                <template #item.llenador.nombre="{ item }">
                  <v-autocomplete
                    v-model="item.llenador"
                    :error="errors.llenador"
                    :items="item.llenadorList"
                    :search-input.sync="item.searchLlenador"
                    dense
                    hide-details
                    item-text="nombre"
                    no-filter
                    return-object
                    @blur="checkEmptyLlenadorList(item)"
                    @keyup.capture="updateLlenadorList(item)"
                  ></v-autocomplete>
                </template>

                <template #item.lecturaInicial="{ item }">
                  <VueAutonumeric
                    v-model.number="item.lecturaInicial"
                    autocomplete="off"
                    dense
                    hide-details
                  ></VueAutonumeric>
                </template>

                <template #item.posicion="{ item }">
                  <VueAutonumeric
                    v-model.number="item.posicion"
                    :an-options="{ decimalPlaces: 0 }"
                    autocomplete="off"
                    dense
                    hide-details
                  ></VueAutonumeric>
                </template>

                <template #item.action="{ item }">
                  <v-btn-toggle>
                    <v-btn color="green" x-small @click="modifyMetro(item)">
                      <i class="fa fa-edit" style="color: white"></i>
                    </v-btn>
                    <v-btn color="red darken-3" x-small @click="deleteMetro(item)">
                      <i class="fa fa-trash-o"></i>
                    </v-btn>
                  </v-btn-toggle>
                </template>
              </v-data-table>
            </v-col>
          </div>
        </v-col>
        <!-- fn contenido central --->
      </v-row>
    </v-container>
    <!-- Modales --->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import ContenidoBase from "../../components/ContenidoBase"
  import BarraDinamicaLimitePlus from "@/components/BarraDinamicaLimitePlus.vue"
  import VueAutonumeric from "@/components/AutoNumericNuevo.vue"

  export default {
    components: {
      BarraDinamicaLimitePlus,
      ContenidoBase,
      VueAutonumeric,
    },

    mounted() {
      this.findAllTipoGas()
    },

    data() {
      return {
        descripcion: "",
        sucursalList: [],

        newMetro: {
          codigo: 0,
          nombre: "",
          tipoGas: null,
          lecturaInicial: 0,
          llenador: null,
          posicion: 0,
        },

        metro: {
          codigo: 0,
          nombre: "",
          tipoGas: null,
          lecturaInicial: 0,
          llenador: null,
          posicion: 0,
        },

        metroPage: 0,
        pageSize: 20,
        metroList: [],
        metroHeaders: [
          { text: "Metro o Medidor", value: "nombre", width: "auto", sortable: false },
          { text: "Tipo Gas", value: "tipoGas.descripcion", width: "auto", sortable: false },
          { text: "Llenador", value: "llenador.nombre", width: "auto", sortable: false },
          { text: "Lectura Inicial", value: "lecturaInicial", width: "auto", sortable: false },
          { text: "Posicion", value: "posicion", width: "auto", sortable: false },
          { text: "ACCIÓN", value: "action", width: "auto", sortable: false },
        ],

        tipoGasList: [],
        searchLlenador: "",
        llenadorList: [],
        searchLlenadorModificar: "",
        llenadorModificarList: [],
        searchTimeout: null,

        totalItems: 0,
        paginador: {
          page: 1,
          itemsPerPage: 5,
          pageStart: 1,
          pageStop: 15,
          pageCount: 10,
          itemsLength: 5,
        },
        showBarraPrimaria: false,

        errors: {
          nombre: false,
          tipoGas: false,
          lecturaInicial: false,
          llenador: false,
          posicion: false,
        },

        windowSize: { width: "auto", height: "auto" },

        sucursalMetroNuevo: {
          codigo: 0,
          descripcion: "",
          telefono: "",
          direccion: "",
          activada: false,
        },

        sucursalMetro: {
          codigo: 0,
          descripcion: "",
          telefono: "",
          direccion: "",
          activada: false,
        },

        EstadoBtn: {
          BarraTablaDinamicaAprir: true,
          nuevo: false,
          guardar: false,
          eliminar: false,
        },

        valid: true,
        validForm: true,

        notif: {
          estado: false,
          nombre: "",
          Exec: "",
        },

        aalert: {
          estado: false,
          color: null,
        },
      }
    },

    methods: {
      abrirTabla() {
        this.showBarraPrimaria = !this.showBarraPrimaria
      },

      datostabla(e) {
        Object.assign(this.sucursalMetro, e)
        this.findAllMetroBySucursal()
      },

      guardar() {
        if (this.$refs.form.validate()) {
        } else {
          this.alerta("Los campos en rojo son requeridos", "error")
        }
      },

      validateMetroForm() {
        let metro = this.metro
        let valid = true

        if (metro.nombre === "") {
          this.errors.nombre = true
          valid = false
        } else {
          this.errors.nombre = false
        }

        if (metro.tipoGas === null) {
          this.errors.tipoGas = true
          valid = false
        } else {
          this.errors.tipoGas = false
        }

        if (metro.llenador === null) {
          this.errors.llenador = true
          valid = false
        } else {
          this.errors.llenador = false
        }

        return valid
      },

      saveMetro() {
        if (!this.validateMetroForm()) {
          this.alerta("Llene los campos necesarios", "error")
          return
        }
        this.metro.sucursal = this.sucursalMetro

        this.$axios
          .post(this.$hostname + this.$hName + `/metros-estacion`, this.metro, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((response) => {
            this.alerta("Metro guardado exitosamente!", "bien")
            Object.assign(this.metro, this.newMetro)
            this.findAllMetroBySucursal()
          })
          .catch((error) => {
            console.error(error)
            this.alerta("Error al guardar el metro!", "error")
          })
      },

      eliminar() {},

      anular() {},

      newwnuevo() {
        Object.assign(this.sucursalMetro, this.sucursalMetroNuevo)

        this.errors = {
          nombre: false,
          tipoGas: false,
          lecturaInicial: false,
          llenador: false,
          posicion: false,
        }
      },

      alerta(e, l) {
        if (l === "bien") {
          this.aalert.estado = true
          this.aalert.color = "success"
          this.aalert.nombre = e
        }

        if (l === "error") {
          this.aalert.estado = true
          this.aalert.color = "error"
          this.aalert.nombre = e

          this.ejecucion = false
        }
      },

      // Un metodo que se llama cuando el usuario cambia la página de la tabla.
      cargarPaginacion(e, s) {
        if (e.itemsPerPage == -1) {
          e.itemsPerPage = 15
        }
        this.paginador = JSON.parse(JSON.stringify(e))
        this.descripcion = s
        this.findAllSucursales()
      },

      findAllSucursales() {
        this.$axios
          .get(this.$hostname + this.$hName + "/sucursal", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              descripcion: this.descripcion,
              page: this.paginador.page - 1,
            },
          })
          .then((response) => {
            this.sucursalList = response.data.content
            this.totalItems = response.data.totalElements
          })
          .catch((error) => {
            console.error(error)
          })
      },

      findAllMetroBySucursal() {
        let codigoSucursal = this.sucursalMetro.codigo

        this.$axios
          .get(this.$hostname + this.$hName + `/metros-estacion/${codigoSucursal}`, {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              page: this.metroPage,
              size: this.pageSize,
            },
          })
          .then((response) => {
            this.metroList = response.data
            this.metroList.content.forEach((value) => {
              value.searchLlenador = value.llenador.nombre
              value.llenadorList = [value.llenador]
            })
          })
          .catch((error) => {
            console.error(error)
          })
      },

      resetMetroForm() {
        Object.assign(this.metro, this.newMetro)

        this.errors = {
          nombre: false,
          tipoGas: false,
          lecturaInicial: false,
          llenador: false,
          posicion: false,
        }
      },

      // Los tipos de gas se encuentran en los departamentos
      findAllTipoGas() {
        this.$axios
          .get(this.$hostname + this.$hName + "/departamento/findall", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((response) => {
            this.tipoGasList = response.data
          })
          .catch((error) => {
            console.error(error)
          })
      },

      // Buscar vendedor por nombre
      findLlenador() {
        this.$axios
          .get(this.$hostname + this.$hName + "/vendedores/findAllByNombre", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              nombre: this.searchLlenador,
            },
          })
          .then((res) => {
            this.llenadorList = res.data.content
          })
          .catch((err) => {
            console.error(err)
          })
      },

      deleteMetro(item) {
        let codigo = item.codigo
        this.$axios
          .delete(this.$hostname + this.$hName + `/metros-estacion/${codigo}`, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((response) => {
            this.alerta("Metro eliminado exitosamente!", "bien")
            this.findAllMetroBySucursal()
          })
          .catch((error) => {
            console.error(error)
            this.alerta("Error al eliminar el metro!", "error")
          })
      },

      modifyMetro(item) {
        this.$axios
          .put(this.$hostname + this.$hName + `/metros-estacion`, item, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((response) => {
            this.alerta("Metro modificado exitosamente!", "bien")
            this.findAllMetroBySucursal()
          })
          .catch((error) => {
            console.error(error)
            this.alerta("Error al modificar el metro!", "error")
          })
      },

      findLlenadorModificar(item) {
        return this.$axios
          .get(this.$hostname + this.$hName + "/vendedores/findAllByNombre", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              nombre: item.searchLlenador,
            },
          })
          .then((res) => {
            return res.data.content
          })
          .catch((err) => {
            console.error(err)
          })
      },

      async updateLlenadorList(item) {
        clearTimeout(this.searchTimeout)
        this.searchTimeout = setTimeout(async () => {
          const data = await this.findLlenadorModificar(item)

          // Create an updated item object
          const updatedItem = { ...item, llenadorList: data }

          // Find the index of the item to be updated
          const itemIndex = this.metroList.content.findIndex((metro) => metro.codigo === item.codigo)

          if (itemIndex > -1) {
            // Replace the item in the array with the new one
            this.metroList.content.splice(itemIndex, 1, updatedItem)
          }
        }, 300)
      },

      checkEmptyLlenadorList(item) {
        if (item.llenadorList.length === 0 || !item.llenadorList.includes(item.llenador)) {
          item.llenadorList.unshift(item.llenador)
        }
      },

      changePage(pageNumber) {
        this.metroPage = pageNumber - 1
        this.findAllMetroBySucursal()
      },
    },

    watch: {
      searchLlenador() {
        this.findLlenador()
      },
    },
  }
</script>

<style></style>
